export class GroupModel {
	id: string;
	name: string;
	collection_name: string;
}
